import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const Unauthorized = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const fromAuth = sessionStorage.getItem('redirected_from_auth');
    if (!fromAuth) {
      navigate('/');
    } else {
      sessionStorage.removeItem('redirected_from_auth');
    }
  }, [navigate]);

  const handleGoBack = () => {
    navigate('/');
  };

  return (
    <div className="flex flex-col items-center justify-center h-screen text-center">
      <h2 className="text-3xl text-red-600 mb-2"> Access Denied</h2>
      <h1 className="text-2xl">You are not authorized to access this page.</h1>
      <button
        onClick={handleGoBack}
        className="px-6 py-2 border border-gray rounded mt-14"
      >
        Go Back
      </button>
    </div>
  );
};

export default Unauthorized;
